import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const GoogleCircle24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg32, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
  >
    <path
      className={cn(
        chroma === 'default' && s.googleFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M15.96 2.16c7.616 0 13.8 6.184 13.8 13.8 0 7.616-6.184 13.8-13.8 13.8-7.616 0-13.8-6.184-13.8-13.8 0-7.616 6.184-13.8 13.8-13.8zm-.18 7.92a5.696 5.696 0 00-4.985 2.936l-.109.204-.122.26a5.695 5.695 0 000 4.6l.122.26.109.204a5.696 5.696 0 004.985 2.936c1.539 0 2.83-.51 3.772-1.381 1.078-.992 1.7-2.454 1.7-4.19a6.55 6.55 0 00-.104-1.165H15.78v2.204h3.068l-.049.213a2.61 2.61 0 01-.93 1.393l-.159.115-.175.109c-.482.275-1.073.435-1.755.435-1.485 0-2.741-1.003-3.19-2.35a3.426 3.426 0 01-.178-1.083c0-.376.065-.741.179-1.083l.063-.174c.495-1.259 1.706-2.176 3.126-2.176.837 0 1.588.288 2.179.852l1.635-1.634-.189-.169c-.96-.82-2.185-1.316-3.625-1.316z"
      fillRule="evenodd"
    />
  </svg>
);

export default GoogleCircle24;
